var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "appstore clear" }, [
    _vm.download
      ? _c("div", { staticClass: "download-guide" }, [
          _c("img", { attrs: { src: "/public/download_guide.png" } }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.desktop
      ? _c("div", { staticClass: "btn-download-group" }, [
          _c("a", { attrs: { href: this.$config.iOSAPPUrl } }, [
            _c("img", { attrs: { src: "/public/App store-min.png" } }),
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: this.$config.androidAPPUrl } }, [
            _c("img", { attrs: { src: "/public/Google Play-min.png" } }),
          ]),
        ])
      : _c("div", { staticClass: "btn-download-group" }, [
          _vm.ios
            ? _c(
                "a",
                {
                  attrs: { href: this.$config.iOSAPPUrl },
                  on: { click: _vm.handleEvent },
                },
                [_c("img", { attrs: { src: "/public/App store-min.png" } })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.android
            ? _c(
                "a",
                {
                  attrs: { href: this.$config.androidAPPUrl },
                  on: { click: _vm.handleEvent },
                },
                [_c("img", { attrs: { src: "/public/Google Play-min.png" } })]
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Appstore.vue